export default item => (
  item && item.name && item.record
    ? `${item.name}-${item.state} ${item.record}`
    : ''
);
